import React, { Component, PropTypes } from 'react';
import { intlShape } from 'react-intl';
import classNames from 'classnames';
import { autobind } from 'core-decorators';

import AverageRating from 'AppComponents/AverageRating';

import MapIcon from '../MapIcon';
import Pin from '../Pin';
import Bubble from '../Bubble';

import '../styles.scss';


class PlaceMarker extends Component {

  static propTypes = {
    allowHover: PropTypes.bool,
    intl: intlShape,
    listHovered: PropTypes.bool,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    place: PropTypes.shape({
      pk: PropTypes.string,
      name: PropTypes.string,
      category: PropTypes.string,
      average_rating: PropTypes.number,
      average_walkability_rating: PropTypes.number,
    }).isRequired,
  };

  static defaultProps = {
    allowHover: true,
    intl: null,
    listHovered: false,
    onClick: () => {},
    onMouseEnter: () => {},
    onMouseLeave: () => {},
  };

  static contextTypes = {
    intl: intlShape,
  };

  static childContextTypes = {
    intl: intlShape,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      hovered: false,
    };
  }

  getChildContext() {
    return {
      intl: this.props.intl || this.context.intl,
    };
  }

  @autobind
  onClick() {
    this.props.onClick(this.props.place.pk);
  }

  @autobind
  onMouseEnter() {
    this.setState({ hovered: true });
    this.props.onMouseEnter(this.props.place.pk);
  }

  @autobind
  onMouseLeave() {
    this.setState({ hovered: false });
    this.props.onMouseLeave(this.props.place.pk);
  }

  render() {
    const { place, listHovered, allowHover } = this.props;
    const hovered = this.state.hovered;
    return (
      <MapIcon
        className={classNames('place', place.category, {
          hovered,
          'list-hovered': listHovered,
        })}
        styleName='place'
        onClick={this.onClick}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <Pin />
        { hovered && allowHover ?
          <Bubble>

            <h4>{ place.name }</h4>

            { place.average_rating ?
              <AverageRating rating={place.average_rating} />
            : null }

            { place.average_walkability_rating ?
              <AverageRating rating={place.average_walkability_rating} type='walk' />
            : null }

          </Bubble>
        : null }
      </MapIcon>
    );
  }
}

export default PlaceMarker;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/MapMarker/Place/index.jsx